export const isProd =
  import.meta.env.VITE_STATIC_ENV === 'production' ||
  window.location.hostname.match(/123jobs.com/);

export const isStage =
  import.meta.env.VITE_STATIC_ENV === 'development' ||
  window.location.hostname.match(/stage.123jobs.com/);
